const updColeccMANY = (creaColeccMany1, createColecc) => {
  let numDocCRUD = 0, totDocCRUD = 1, argsCrud = [], crudColecc = []
  for(let iii=0; iii<totDocCRUD; iii++){
    argsCrud.push({ctrlCampo: 'MANY'})
  }
  for(let iii=0; iii<totDocCRUD; iii++){
    crudColecc.push(createColecc)
  }

  argsCrud[numDocCRUD] = creaColeccMany1[0]
  argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
  argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
  crudColecc[numDocCRUD] = createColecc

  let updColecc ={crudColecc, argsCrud, totDocCRUD}
  return(updColecc)
}

export default updColeccMANY
